import i18next from "i18next";

import { getToken } from "../../utils/OktaHelpers";
import { getUserAttributeObj } from "../../utils/UserHelper";

const HTTP_HEADER_VALUES = Object.freeze({
    skip: "skip",
});

const HTTP_HEADERS = Object.freeze({
    authorization: "Authorization",
    neospectraLanguage: "neospectra-language",
    neospectraId: "neospectra-organization-id",
    neospectraSource: "X-NeoSpectra-Request-Source",
    neospectraPredictServiceKey: "X-NeoSpectra-Predict-Service-Key",
});

const HTTP_PREDEFINED_HEADERS = Object.freeze({
    skipLanguage: {
        [HTTP_HEADERS.neospectraLanguage]: HTTP_HEADER_VALUES.skip,
    },
});

const handleRequestHeaders = (request, skipAuthentication = false) => {
    const organizationId = getUserAttributeObj("organization")?.id;
    request.headers[HTTP_HEADERS.neospectraSource] = "Portal";

    if (!skipAuthentication)
        request.headers[HTTP_HEADERS.authorization] = "bearer " + getToken();

    if (
        request.headers[HTTP_HEADERS.neospectraLanguage] !=
        HTTP_HEADER_VALUES.skip
    )
        request.headers[HTTP_HEADERS.neospectraLanguage] = i18next.language;

    if (organizationId)
        request.headers[HTTP_HEADERS.neospectraId] = organizationId;

    return request;
};

const handleAlligatorRequestHeaders = (request) => {
    request.headers[HTTP_HEADERS.neospectraPredictServiceKey] =
        process.env.REACT_APP_ALLIGATOR_API_KEY;

    request.headers["Accept"] = "*/*";
    request.headers["Content-Type"] = "application/json";
    return request;
};

const handleBuchiWebserivceRequestHeaders = (request) => {
    request.headers[HTTP_HEADERS.neospectraPredictServiceKey] =
        process.env.REACT_APP_BUCHI_WEBSERVICE_API_KEY;

    request.headers["Accept"] = "*/*";
    request.headers["Content-Type"] = "application/json";
    return request;
};

export {
    handleRequestHeaders,
    handleAlligatorRequestHeaders,
    handleBuchiWebserivceRequestHeaders,
    HTTP_HEADERS,
    HTTP_HEADER_VALUES,
    HTTP_PREDEFINED_HEADERS,
};
